import * as React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import careerpagebg from "../../../assets/career-development.png";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';

export default function Job_box({ item = {} }) {
  const navigate = useNavigate(); // Initialize navigation

  const handleNavigation = () => {
    navigate('/Job_Details', { state: { data: item } }); // Pass job data as state
  };

  return (
    <Card
      elevation={3} sx={{width: 450, minHeight: 250,borderRadius: 2,margin: '10px'}}>
      <CardActionArea onClick={handleNavigation} sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <CardContent sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
          {/* Header */}
          <div style={{ backgroundColor: "black", marginBottom: '10px',width:400, padding: '10px', borderRadius: '0px 0px 10px 10px', display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="body2" fontWeight="bold" color="#fff"> {item.jobtitle || "N/A"}</Typography>
          </div>
    
          {/* Location */}
          <Typography variant="body2" color="text.secondary">
            <strong>Location:</strong> {item.location || "N/A"}
          </Typography>

          {/* Qualification */}
          <Typography variant="body2" color="text.secondary">
            <strong>Qualification:</strong> {item.qualification || "N/A"}
          </Typography>

 {/* Qualification */}
          <Typography variant="body2" color="text.secondary">
            <strong>Jobtype :</strong> {item.jobtype || "N/A"}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>Budget:</strong> {item.budget || "N/A"}
          </Typography>

          {/* Job Description
          <div style={{ marginTop: '8px' }}>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 'bold' }}>
              Description:
            </Typography>
            <div
              style={{ color: '#555', fontSize: '0.875rem' }}
              dangerouslySetInnerHTML={{ __html: item.jobdescription || "No description available" }}
            />
          </div> */}


          {/* Read More Link */}
          <Typography variant="body2" color="black" sx={{ marginTop: "auto", fontWeight: 'bold', cursor: 'pointer' }}>
            Apply Now
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
